import loadCustomerModule from './modules/Customer.module';
import loadSessionModule from './modules/Session.module';
const loadAccountRegistrationModule = () => ({
    hasRouter: true,
    modules: [loadSessionModule(), loadCustomerModule()],
});
export default loadAccountRegistrationModule;
